import { buildPagedListPath } from "../../utils/listFilterQuery";
import type { DocumentListRow } from "./DocumentsListTable";

export interface RentProcessListItem {
  id: number;
  property_id: number;
  tenant?: {
    id: number;
    first_name: string;
    email: string;
  };
  updated_at: string;
}

export function buildDocumentsPath(
  page: number,
  search: string,
  hasDocuments: string,
  hasDocumentLink: string
): string {
  return buildPagedListPath("/documents", page, {
    search,
    has_documents: hasDocuments,
    has_document_link: hasDocumentLink,
  });
}

export function mapProcessToRow(process: RentProcessListItem): DocumentListRow {
  return {
    rentProcessId: process.id,
    propertyId: process.property_id,
    name: process.tenant?.first_name ?? "-",
    updated_at: process.updated_at,
  };
}
